import { render, staticRenderFns } from "./frequency-information-add.vue?vue&type=template&id=45b08b6e&scoped=true"
import script from "./frequency-information-add.vue?vue&type=script&lang=js"
export * from "./frequency-information-add.vue?vue&type=script&lang=js"
import style0 from "./frequency-information-add.vue?vue&type=style&index=0&id=45b08b6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b08b6e",
  null
  
)

export default component.exports